import { ListingURLParamType } from "@ldp/common-types";
import { useCallback } from "react";

/**
 * It returns a memoized  updateFilterQueryParams function which updates the url with new query params
 */
export const useUpdateFilterQueryParams = () => {
  return useCallback(
    (params: Record<string, string | string[]>, apply: boolean) => {
      const url = new URL(window.location.href);
      const baseOrigin = url.origin;
      const exisitingParams = new URLSearchParams(url.search);
      let new_params;

      for (const [newParamKey] of Object.entries(params)) {
        // Quick Filters
        if (params[newParamKey] instanceof Array) {
          const newParamVals = params[newParamKey] as string[];
          if (!apply) exisitingParams.delete(newParamKey);
          const filterValues = exisitingParams.getAll(newParamKey);
          newParamVals.forEach((paramVal) => {
            if (!filterValues.includes(paramVal) && apply)
              exisitingParams.append(newParamKey, paramVal);
          });
          new_params = new URLSearchParams([
            ...Array.from(exisitingParams.entries()),
          ]).toString();
        } else {
          const newParamVal = decodeURIComponent(params[newParamKey] as string);

          if (!apply) {
            const filterValues = exisitingParams.getAll(newParamKey);
            exisitingParams.delete(newParamKey);
            filterValues
              .filter((val) => decodeURIComponent(val) !== newParamVal)
              .forEach((updatedParamVal) => {
                exisitingParams.append(newParamKey, updatedParamVal);
              });
            new_params = new URLSearchParams([
              ...Array.from(exisitingParams.entries()),
            ]).toString();
          } else {
            const hasNewParamKey = exisitingParams.has(newParamKey);

            if (
              (newParamKey === ListingURLParamType.SORT ||
                newParamKey === ListingURLParamType.PAGE) &&
              hasNewParamKey
            ) {
              exisitingParams.set(newParamKey, newParamVal);
            } else {
              exisitingParams.append(newParamKey, newParamVal);
            }
            new_params = new URLSearchParams([
              ...Array.from(exisitingParams.entries()),
            ]).toString();
          }
        }
      }

      // Update the page param if it exists in the params
      if (params[ListingURLParamType.PAGE]) {
        // string to URLSearchParams
        const searchParams = new URLSearchParams(new_params);
        // update the page param
        searchParams.set(
          ListingURLParamType.PAGE,
          params[ListingURLParamType.PAGE] as string
        );
        // update the new_params
        new_params = searchParams.toString();
      }

      new_params = new_params ? `?${new_params}` : "";

      return `${baseOrigin}${url.pathname}${new_params}`;
    },
    []
  );
};

export default useUpdateFilterQueryParams;
